module.exports = __webpack_public_path__ + "img/xmasParty12.40e55ac4.jpg";